<div class="bg-image flex-grow-1">
  @if (!!currentUser) {
    @if (currentUser.loggedIn && currentUser.userData?.userId === routeUserId) {
      <nz-own-profile/>
    } @else {
      <nz-foreign-profile/>
    }
  }
</div>
